import selfHtml from './s920-notification.html' with { type: 'text' };;

var statusText
var triggerBtn

import { BASEURL } from "../AppState.js";
import { postData, urlBase64ToUint8Array, sleep, show_modal } from "../utils.js";
import { get_pub_key, sign_gpg } from "../crypt_helper.js";

var root

export async function init(module_root, args) {

    module_root.innerHTML = selfHtml;

    root = module_root;

    statusText = root.querySelector(".notificationStatusDisplay")

    triggerBtn = root.querySelector(".notificationTriggerBtn")

    // TODO    (.notificationClearAllBtn)

    triggerBtn.addEventListener('click', (e) => { triggerNotification(root) });

    root.querySelector(".btn_ok_notification_clicked_success").disabled = true

    // Initialize
    checkPermission();
    addLog('App initialized');

}


// ----------------------------------------------------------------------------------

// Add log entry
function addLog(message) {
    statusText.textContent = message
}
// ----------------------------------------------------------------------------------

// Update permission status
function updateStatus(permission) {
    addLog(`status ${permission}`)

    switch (permission) {
        case 'granted':
            statusText.textContent = '✓ Notifications enabled';
            triggerBtn.disabled = false;
            break;
        case 'denied':
            statusText.textContent = '✗ Notifications blocked';
            break;
        default:
            statusText.textContent = '○ Notifications not enabled';
    }
}

// Check notification permission
function checkPermission() {
    if (!('Notification' in window)) {
        addLog('This browser does not support notifications', 'error');
        statusText.textContent = 'Notifications not supported';
        return;
    }

    const permission = Notification.permission;
    addLog(`Current permission: ${permission}`);
    updateStatus(permission);
}

// ----------------------------------------------------------------------------------

// Subscribe to push notifications
async function subscribeToPush() {
    try {
        addLog('Requesting notification permission...');
        const permission = await Notification.requestPermission();

        if (permission !== 'granted') {
            addLog('Notification permission denied', 'error');
            updateStatus(permission);
            return;
        }

        addLog('Permission granted!', 'success');

        // Register service worker
        addLog('Registering service worker...');
        const swRegistration = await navigator.serviceWorker.register(BASEURL.www + '/js/sw.js', {
            type: 'module'
        });
        addLog('Service worker registered', 'success');

        // Get VAPID public key from server
        addLog('Getting VAPID key...');
        const vapidPublicKey = await fetch(BASEURL.www + '/vapidPublicKey.json').then(r => r.json());

        // Subscribe to push
        addLog('Subscribing to push service...');
        const subscription = await swRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey.vapidPub)
        });

        // Send subscription to server
        addLog('Sending subscription to server...');
        const signed_data = await sign_gpg(JSON.stringify({ subscription }));

        const payload = { signed_data, pubkey: await get_pub_key() }
        const data = await postData(BASEURL.api + '/sw/subscribe', payload);

        console.log(data);
        
        addLog('Successfully subscribed to notifications!', 'success');
        updateStatus('granted');
        return true;
    } catch (error) {
        addLog(`Error: ${error.message}`, 'error');
        console.error('Subscribe error:', error);
    }
}
// ----------------------------------------------------------------------------------

// Trigger notification
async function triggerNotification(root) {

    root.querySelector(".btn_ok_notification_clicked_success").disabled = true

    if (await subscribeToPush() != true)
        return

    await sleep(500);

    try {
        triggerBtn.disabled = true;
        addLog('Sending notification request...');

        const self_test_request = await sign_gpg("SELF_TEST_NOTIFICATION");
        const pgp_pubkey = await get_pub_key();
        const data = await postData(BASEURL.api + '/sw/notify_test', { self_test_request, pgp_pubkey: pgp_pubkey.myKeyPairPublicKey })

        if (data.SELF_TEST_NOTIFICATION != true)
            return addLog("Request failed.", 'error');

        addLog("Notification sent. Click on the notification", 'success');


    } catch (error) {
        addLog(`Error sending notification: ${error.message}`, 'error');
    } finally {
        triggerBtn.disabled = false;
    }
}
// ----------------------------------------------------------------------------------
